import { render } from "./NewUser.vue?vue&type=template&id=c209563e"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=c209563e&lang=css"
script.render = render

export default script